import React, { Component, PropTypes } from 'react'
import {List, ListItem, makeSelectable} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
  return class SelectableList extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
			onSportSelect: PropTypes.func.isRequired
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue,
      });
    }

    handleRequestChange = (event, index) => {
			console.log("Selected: ", index)
			this.props.onSportSelect(index);
      this.setState({
        selectedIndex: index,
      });
    };

    render() {
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          onChange={this.handleRequestChange}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}


SelectableList = wrapState(SelectableList);

export default class SportList extends Component {
	render() {
		const { items } = this.props;
  	const { onSportSelect } = this.props;
		let listItems = [];
		if (items){
			for (let i=0; i < items.length; i++){
				listItems.push(<ListItem
					key={i + 1}
  			  value={items[i]}
  			  primaryText={items[i].toUpperCase()}
					onClick={(e) => {onSportSelect(items[i])}}
  			/>);
  		}
		}
		return (
			<a>
  		  <SelectableList onSportSelect={onSportSelect}>
  		    <Subheader>Sports</Subheader>
					{ listItems }
  		  </SelectableList>
  		</a>
		)
  }
}

SportList.propTypes = {
   items: PropTypes.arrayOf(PropTypes.string).isRequired,
   onSportSelect: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/SportList.jsx